import { AllocationScenarioValuationModel } from 'api';
import { OPM } from 'common/constants/allocations';

/**
 * Determines if OPM inputs should be collapsed based on allocation scenarios.
 * OPM inputs should be collapsed if no scenarios use the OPM allocation method.
 *
 * @param allocationScenarios - Array of allocation scenarios to check
 * @returns true if OPM inputs should be collapsed, false otherwise
 */
const shouldCollapseOPMInputs = (allocationScenarios: AllocationScenarioValuationModel[]): boolean =>
  !allocationScenarios.some(scenario => scenario.scenario_method === OPM);

export default shouldCollapseOPMInputs;
